export enum Affiliation {
  Local,
  NonLocal
}
